import { Component, Input } from '@angular/core';
import { SalvageTabContext } from '../salvage-tab-context';

@Component({
  selector: 'app-salvage-in-cart-tab',
  templateUrl: './salvage-in-cart-tab.component.html',
})
export class SalvageInCartTabComponent {
  @Input() context!: SalvageTabContext;
}
